import { render, staticRenderFns } from "./HeartysanChoice.vue?vue&type=template&id=160cdc81&scoped=true"
import script from "./HeartysanChoice.vue?vue&type=script&lang=js"
export * from "./HeartysanChoice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "160cdc81",
  null
  
)

export default component.exports